export default function CTASection() {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden bg-white">
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://public.readdy.ai/ai/img_res/04153a3e548bcd028d6afda0d5622aa9.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-10"
        />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        {/* Icon */}
        <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-7">
          <i className="ri-money-dollar-circle-line text-3xl text-green-600 w-8 h-8 flex items-center justify-center"></i>
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 tracking-tight mb-5 leading-tight">
          Envía dinero al{' '}
          <span className="text-green-600">mejor tipo de cambio</span>
        </h2>

        <p className="text-gray-500 text-lg max-w-md mx-auto mb-10 leading-relaxed">
          Compara opciones y elige la más barata en segundos. Sin complicaciones, sin sorpresas.
        </p>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 mb-10">
          {[
            { icon: 'ri-shield-check-line', label: 'Seguro y confiable' },
            { icon: 'ri-timer-line', label: 'Actualización diaria' },
            { icon: 'ri-search-line', label: 'Comparación gratuita' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-1.5 text-sm text-gray-500 bg-gray-50 rounded-full px-4 py-2">
              <i className={`${item.icon} text-green-600 w-4 h-4 flex items-center justify-center`}></i>
              <span>{item.label}</span>
            </div>
          ))}
        </div>

        <a
          href="https://remesasve.com"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-500 text-white font-bold text-base rounded-full px-10 py-4 transition-all cursor-pointer whitespace-nowrap hover:scale-105 active:scale-95 shadow-lg shadow-green-200"
        >
          <i className="ri-bar-chart-grouped-line text-lg w-5 h-5 flex items-center justify-center"></i>
          Comparar ahora
        </a>
      </div>
    </section>
  );
}
